import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DraftResponseIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				d="M14.8399 6.22003C13.6799 2.74002 10.7466 1.31282 8.43378 1.31282C4.6045 1.31282 1.5 4.41733 1.5 8.24777C1.5 9.50869 1.84185 10.6885 2.43125 11.7075C2.84189 12.4789 2.38125 14.3015 1.5 15.1816C2.69538 15.2459 4.27146 14.7065 4.97408 14.2503C5.34307 14.4633 6.71987 15.5 9.03987 14.92"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M9.76719 11.1458C10.9876 10.7833 11.9661 9.86741 12.4083 8.67361L12.6314 8.07125L12.8143 8.68702C13.1768 9.9074 14.0927 10.8859 15.2865 11.3281L15.8889 11.5513L15.2731 11.7341C14.0527 12.0966 13.0742 13.0126 12.632 14.2063L12.4089 14.8087L12.226 14.1929C11.8635 12.9726 10.9476 11.9941 9.75378 11.5518L9.15142 11.3287L9.76719 11.1458Z"
				stroke="currentColor"
				strokeWidth="1"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	),
)
